import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentHeader } from 'components/ui/layout/ContentHeader';
import { DarwinFlex } from 'components/darwin-ui';
import {
  CategoriesCollapse,
  DataItem,
} from 'components/ui/dataTables/CategoriesCollapse';
import { DataFields } from 'components/ui/dataTables/DataFields';
import styles from './index.module.css';

export const DataTables = () => {
  const { t } = useTranslation();

  const [selectedKey, setSelectedKey] = useState<DataItem | null>(null);

  return (
    <DarwinFlex vertical>
      <ContentHeader title={t('data-tables.title')} />

      <DarwinFlex className={styles.contentContainer}>
        <CategoriesCollapse
          selectedKey={selectedKey || undefined}
          onSelect={setSelectedKey}
        />

        <DataFields
          processId={selectedKey?.key || ''}
          categoryName={selectedKey?.label || ''}
        />
      </DarwinFlex>
    </DarwinFlex>
  );
};
